import loader from './reducers'

export { load, unload } from './actions'
// export { shouldLoad } from './selectors'

export default loader
